import { buildQuery } from '@/lib/helper';
import client from '@/lib/http-client';

const endpoint = '/wallet/topup';

export default {
	/**
	 * Get Admin Topup List
	 * @param {Object} params - Query parameters (page, limit, sort_by, sort, since, until, status, keyword)
	 * @param {requestCallback} cb
	 * @param {errorCallback} errorCb
	 */
	getAdminList(params, cb, errorCb) {
		const query = buildQuery(params);
		const url = `${endpoint}/admin/list?${query}`;
		client.get(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	/**
	 * Get Admin Topup Scoreboard
	 * @param {Object} params - Query parameters (since, until, status, keyword)
	 * @param {requestCallback} cb
	 * @param {errorCallback} errorCb
	 */
	getAdminScoreboard(params, cb, errorCb) {
		const query = buildQuery(params);
		const url = `${endpoint}/admin/scoreboard?${query}`;
		client.get(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	/**
	 * Export Admin Topup List
	 * @param {Object} params - Query parameters (sort_by, sort, since, until, status, keyword)
	 * @param {requestCallback} cb
	 * @param {errorCallback} errorCb
	 */
	exportAdmin(params, cb, errorCb) {
		const url = `${endpoint}/admin/export`;
		client.post(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},
};
